import {buildRequest} from '../stateUtil';

export const getFeatureFlagsForGroup = (groupId) =>
  buildRequest(
    'GET_GROUPS_FEATURE_FLAGS',
    'GET',
    `groups/${groupId}/featureFlags`
  );
